export const TASK_OUTPUT_TOOL_NAME = 'TaskOutput'
